"use client";

import { Scale, ShieldCheck, FileText, Gavel } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Corporategovernancegrid() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const features = [{
    icon: Scale,
    title: "Business Formation & Governance",
    description: "Comprehensive counsel for entity selection, corporate structuring, shareholder agreements, and ongoing compliance to protect corporate value.",
    link: "/BusinessCorporateServicesPage"
  }, {
    icon: ShieldCheck,
    title: "Selective Business Litigation",
    description: "Strategic, measured dispute resolution and trial advocacy for closely held businesses, partnership disagreements, and commercial breaches.",
    link: "/BusinessLitigationPage"
  }, {
    icon: FileText,
    title: "Contract Negotiation & Risk",
    description: "Meticulous drafting and review of complex commercial agreements, vendor contracts, and ownership transition documentation.",
    link: "/BusinessCorporateServicesPage"
  }, {
    icon: Gavel,
    title: "Expert Testimony & Hearings",
    description: "Serving as an authoritative Expert Witness in Attorney’s Fee Hearings with deep judicial familiarity and professional integrity.",
    link: "/AttorneyFeeHearingsPage"
  }];
  const FeatureItem = ({
    feature,
    index
  }: {
    feature: (typeof features)[number];
    index: number;
  }) => {
    const {
      ref,
      isVisible
    } = useRevealOnScroll<HTMLDivElement>({
      threshold: 0.2
    });
    const Icon = feature.icon;
    return <div ref={ref} data-index={index} className="group relative flex flex-col justify-between p-8 bg-card border border-border/60 hover:border-primary/40 rounded-lg shadow-sm hover:shadow-md transition-all duration-500 ease-out" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(24px)",
      transitionDelay: `${index * 120}ms`
    }}>
        <div>
          <div className="size-14 rounded-lg bg-accent flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
            <Icon className="size-7 stroke-[1.25] text-primary group-hover:text-primary-foreground transition-colors duration-300" strokeWidth={1.25} />
          </div>
          <h3 className="font-serif text-xl font-medium mb-4 text-foreground">
            {feature.title}
          </h3>
          <p className="font-default text-[15px] text-muted-foreground mb-8" style={{
          lineHeight: 1.7
        }}>
            {feature.description}
          </p>
        </div>
        <div className="pt-4 border-t border-border/40">
          <Link to={feature.link} className="inline-flex items-center text-sm font-medium text-primary hover:text-secondary transition-colors duration-200">
            <span>Learn more</span>
            <span className="ml-2 transition-transform duration-200 group-hover:translate-x-1">&rarr;</span>
          </Link>
        </div>
      </div>;
  };
  return;
}